import { ProductTileContainer } from "@faire/web-api--source/indigofair/data/ProductTileContainer";
import { ProductTileScreen } from "@faire/web-api--source/indigofair/data/ProductTileScreen";
import { ProductTileScreenContainer } from "@faire/web-api--source/indigofair/data/ProductTileScreenContainer";
import React, { PropsWithChildren } from "react";

import { ProductTileClickImpressionProvider } from "@faire/retailer/hooks/ProductTileImpression/ProductTileClickImpressionProvider";
import { ProductTileViewImpressionProvider } from "@faire/retailer/hooks/ProductTileImpression/ProductTileViewImpressionProvider";
import { Category } from "@faire/retailer/models/Category/Category";

interface IProductTileImpressionsProviderProps {
  requestId: string | undefined;
  category?: Category;
  onClickEventName?: string;
}

export const ProductTileImpressionsProvider: React.FC<
  PropsWithChildren<IProductTileImpressionsProviderProps>
> = ({ children, requestId, onClickEventName, category }) => {
  const context: `${keyof typeof ProductTileContainer}|${string}` = `${ProductTileContainer.CATEGORY_PRODUCT_RESULTS_LAYOUT_ELEMENT_CAROUSEL}|${category?.mostSpecificPathIdentifier}|${onClickEventName}`;

  return (
    <ProductTileViewImpressionProvider
      context={context}
      screenContext={ProductTileScreen.PRODUCT_TILE_SCREEN_UNKNOWN}
      containerContext={
        ProductTileScreenContainer.PRODUCT_TILE_SCREEN_CONTAINER_UNKNOWN
      }
      requestId={requestId}
    >
      <ProductTileClickImpressionProvider
        context={context}
        screenContext={ProductTileScreen.PRODUCT_TILE_SCREEN_UNKNOWN}
        containerContext={
          ProductTileScreenContainer.PRODUCT_TILE_SCREEN_CONTAINER_UNKNOWN
        }
        contextToken=""
        productTileContainer={
          ProductTileContainer.CATEGORY_PRODUCT_RESULTS_LAYOUT_ELEMENT_CAROUSEL
        }
        requestId={requestId}
      >
        {children}
      </ProductTileClickImpressionProvider>
    </ProductTileViewImpressionProvider>
  );
};
